export default __webpack_public_path__ + "static/RecklessNeue-Light-3473530ace773594264232a1773ddcf0.woff2";